import { Grid, Typography } from "@mui/material";
import { useContext } from "react";
import { EditTrackingNumber, ShipmentDetails, ShipmentLines } from "./components";
import { shipmentContext } from "./ShipmentContext";

let Shipment = () => {
    let service = useContext(shipmentContext);

    return (
        <Grid container>
            <Grid item xs={12}>
                <Grid container>
                    <Grid item xs>
                        <Typography variant="h3">Shipment</Typography>
                    </Grid>
                    <Grid item>
                        {service.shipment?.canAddTrackingNumber === true &&
                            <EditTrackingNumber
                                id={service.shipment.id}
                                shipmentId={service.shipment.shipmentId}
                                trackingNumber={service.shipment.trackingNumber}
                            />
                        }
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={4}>
                <ShipmentDetails />
            </Grid>
            <Grid item xs={8}>
                <ShipmentLines />
            </Grid>
        </Grid >
    );
}

export default Shipment;